import { render, staticRenderFns } from "./TransferCard.vue?vue&type=template&id=73b5e989&"
import script from "./TransferCard.vue?vue&type=script&lang=js&"
export * from "./TransferCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports